import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 *
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(args: { id: string }) => string} [deps.buildUrl]
 */
export function usePutVocab({ callApiWithWorker, buildUrl }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["putVocab"],

    mutationFn: async ({ id, payload }) => {
      const normalizedId = id ? String(id) : null;
      if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
        throw new Error("Vocab payload is required");
      }

      const { id: _id, identifier: _identifier, ...cleanPayload } = payload;

      const url =
        typeof buildUrl === "function"
          ? buildUrl({ id: normalizedId || "" })
          : "/api/vocabularyHub/update";

      const res = await callApiWithWorker(url, {
        method: "PUT",
        body: cleanPayload,
      });

      const statusCode = res?.statusCode ?? res?.data?.statusCode;
      const bodyString = res?.body ?? res?.data?.body;

      if (statusCode && statusCode >= 400) {
        let message = "Vocabulary update failed";
        try {
          const parsed =
            typeof bodyString === "string"
              ? JSON.parse(bodyString)
              : bodyString;
          message = parsed?.message ?? message;
        } catch {}
        throw new Error(message);
      }

      return typeof bodyString === "string"
        ? JSON.parse(bodyString)
        : bodyString;
    },

    onSuccess: (_data, variables) => {
      const resolvedId =
        variables?.id ||
        variables?.payload?.resource_id ||
        variables?.payload?.identifier ||
        variables?.payload?.id;

      queryClient.invalidateQueries({ queryKey: ["vocabsPaginated"] });
      if (resolvedId) {
        queryClient.invalidateQueries({
          queryKey: ["vocabById", String(resolvedId)],
        });
      }
    },
  });
}
